import * as styles from './Container.module.scss';

export interface ContainerProps {
  env: 'dev' | 'prod';
}

const Container = ({ env }: ContainerProps) => (
  <>
    <h1 className={styles.container}>
      {`This is the ratings and reviews container in the ${env} env!`}
    </h1>
  </>
);

export default Container;
